import { render } from "./Algo.vue?vue&type=template&id=680f35ac&scoped=true"
import script from "./Algo.vue?vue&type=script&lang=js"
export * from "./Algo.vue?vue&type=script&lang=js"

import "./Algo.vue?vue&type=style&index=0&id=680f35ac&scoped=true&lang=css"

import exportComponent from "/Users/walt/WORK/school/portfolio/s1-crypto-prng/prng/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680f35ac"]])

export default __exports__